function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#share_svg__clip0_1627:1228)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.538 9.181l-7.333-7.666c-1.03-1.075-2.872-.359-2.872 1.152V6.34C6.44 6.423 0 7.671 0 14.8c0 3.957 2.327 6.26 3.714 7.273 1.01.739 2.417-.208 2.07-1.438-1.578-5.598 1.115-6.22 7.55-6.295V18c0 1.51 1.84 2.229 2.87 1.152l7.334-7.667a1.667 1.667 0 000-2.304zm-.964 1.383l-7.333 7.666a.333.333 0 01-.574-.23v-5c-7.142 0-12.305.405-10.166 7.988C3 19.89 1.333 17.9 1.333 14.8c0-6.668 6.787-7.133 13.334-7.133v-5c0-.303.369-.446.574-.23l7.333 7.666a.333.333 0 010 .46z",
  fill: "#fff"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "share_svg__clip0_1627:1228"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgShare;